export default "__VITE_ASSET__1f7712b2__"